export interface LocationOption {
    value: string;
    labelEn: string;
    labelAr: string;
}

export const sudanStates: LocationOption[] = [
    { value: "Khartoum", labelEn: "Khartoum", labelAr: "الخرطوم" },
    { value: "West Kordofan", labelEn: "West Kordofan", labelAr: "غرب كردفان" },
    { value: "Red Sea", labelEn: "Red Sea", labelAr: "البحر الأحمر" },
    { value: "West Darfur", labelEn: "West Darfur", labelAr: "غرب دارفور" },
    { value: "Kassala", labelEn: "Kassala", labelAr: "كسلا" },
    { value: "North Darfur", labelEn: "North Darfur", labelAr: "شمال دارفور" },
    { value: "South Darfur", labelEn: "South Darfur", labelAr: "جنوب دارفور" },
    { value: "North Kordofan", labelEn: "North Kordofan", labelAr: "شمال كردفان" },
    { value: "Gedaref", labelEn: "Gedaref", labelAr: "القضارف" },
    { value: "Gezira", labelEn: "Gezira", labelAr: "الجزيرة" },
    { value: "White Nile", labelEn: "White Nile", labelAr: "النيل الأبيض" },
    { value: "East Darfur", labelEn: "East Darfur", labelAr: "شرق دارفور" },
    { value: "Sennar", labelEn: "Sennar", labelAr: "سنار" },
    { value: "Blue Nile", labelEn: "Blue Nile", labelAr: "النيل الأزرق" },
    { value: "River Nile", labelEn: "River Nile", labelAr: "نهر النيل" },
    { value: "South Kordofan", labelEn: "South Kordofan", labelAr: "جنوب كردفان" },
    { value: "Northern", labelEn: "Northern", labelAr: "الشمالية" },
    { value: "Central Darfur", labelEn: "Central Darfur", labelAr: "وسط دارفور" },
];

export const sudanCitiesByState: Record<string, LocationOption[]> = {
    "Khartoum": [
        { value: "Khartoum", labelEn: "Khartoum", labelAr: "الخرطوم" },
        { value: "Omdurman", labelEn: "Omdurman", labelAr: "أم درمان" },
        { value: "Khartoum North", labelEn: "Khartoum North", labelAr: "الخرطوم بحري" },
    ],
    "West Kordofan": [
        { value: "Al Mijlad", labelEn: "Al Mijlad", labelAr: "المجلد" },
        { value: "An Nuhūd", labelEn: "An Nuhūd", labelAr: "النهود" },
        { value: "El Fula", labelEn: "El Fula", labelAr: "الفولة" },
    ],
    "Red Sea": [
        { value: "Port Sudan", labelEn: "Port Sudan", labelAr: "بورتسودان" },
        { value: "Sawākin", labelEn: "Sawākin", labelAr: "سواكن" },
        { value: "Tokār", labelEn: "Tokār", labelAr: "طوكر" },
    ],
    "West Darfur": [
        { value: "El Geneina", labelEn: "El Geneina", labelAr: "الجنينة" },
    ],
    "Kassala": [
        { value: "Kassala", labelEn: "Kassala", labelAr: "كسلا" },
    ],
    "North Darfur": [
        { value: "El Fasher", labelEn: "El Fasher", labelAr: "الفاشر" },
        { value: "Kutum", labelEn: "Kutum", labelAr: "كتم" },
    ],
    "South Darfur": [
        { value: "Nyala", labelEn: "Nyala", labelAr: "نيالا" },
    ],
    "North Kordofan": [
        { value: "El Obeid", labelEn: "El Obeid", labelAr: "الأبيض" },
        { value: "Umm Ruwaba", labelEn: "Umm Ruwaba", labelAr: "أم روابة" },
    ],
    "Gedaref": [
        { value: "Gedaref", labelEn: "Gedaref", labelAr: "القضارف" },
    ],
    "Gezira": [
        { value: "Wad Medani", labelEn: "Wad Medani", labelAr: "ود مدني" },
        { value: "Al Manāqil", labelEn: "Al Manāqil", labelAr: "المناقل" },
    ],
    "White Nile": [
        { value: "Kūstī", labelEn: "Kūstī", labelAr: "كوستي" },
        { value: "Ad Diwem", labelEn: "Ad Diwem", labelAr: "الدويم" },
        { value: "Rabak", labelEn: "Rabak", labelAr: "ربك" },
    ],
    "East Darfur": [
        { value: "Ed Daein", labelEn: "Ed Daein", labelAr: "الضعين" },
    ],
    "Sennar": [
        { value: "Singa", labelEn: "Singa", labelAr: "سنجة" },
        { value: "Sannār", labelEn: "Sannār", labelAr: "سنار" },
    ],
    "Blue Nile": [
        { value: "Kurmuk", labelEn: "Kurmuk", labelAr: "الكرمك" },
        { value: "Ar Ruseris", labelEn: "Ar Ruseris", labelAr: "الروصيرص" },
        { value: "Ed Damazin", labelEn: "Ed Damazin", labelAr: "الدمازين" },
    ],
    "River Nile": [
        { value: "Atbara", labelEn: "Atbara", labelAr: "عطبرة" },
        { value: "Ed Damer", labelEn: "Ed Damer", labelAr: "الدامر" },
        { value: "Shendi", labelEn: "Shendi", labelAr: "شندي" },
        { value: "Abū Ḩamad", labelEn: "Abū Ḩamad", labelAr: "أبو حمد" },
    ],
    "South Kordofan": [
        { value: "Kadugli", labelEn: "Kadugli", labelAr: "كادقلي" },
    ],
    "Northern": [
        { value: "Dongola", labelEn: "Dongola", labelAr: "دنقلا" },
        { value: "Ad Dabbah", labelEn: "Ad Dabbah", labelAr: "الدبة" },
    ],
    "Central Darfur": [
        { value: "Zalingei", labelEn: "Zalingei", labelAr: "زالنجي" },
    ],
};
